<template>
    <v-menu
      offset-x
      :close-on-content-click="false"
      :nudge-width="200"
      v-model="menu"
    >
      <v-btn flat slot="activator">
        <v-icon>account_circle</v-icon>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon>face</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ fullName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ userName }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <!-- Add profile items here -->
        <v-list/>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="menu = false">Cancel</v-btn>
          <v-btn color="primary" flat @click="logout">
            <span>Logout</span>
            <v-icon>exit</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>

<script>
export default {
  computed: {
    profile () { return this.$store.getters['auth/profile'] },
    userName () { return this.profile.user_name ? this.profile.user_name : '' },
    fullName () { return this.profile.name ? this.profile.name : '' },
  },

  data: () => ({
    menu: false,
  }),

  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>
